/**
 * MyPage
 * @module pages/MyPage
 */

import Layout from 'components/ui/Layout';
import ContentArea from 'components/framework/ContentArea';
import Breadcrumbs from 'components/framework/Breadcrumbs';
import SectionHeader from 'components/ui/SectionHeader';
import {
	CategoryList,
	CategoryListItem,
} from 'components/framework/CategoryList';
import { Cell, Grid } from 'components/ui/Grid';

const MyPage = ({
	heading,
	breadcrumbs,
	text,
	isInEditMode,
	columnList,
	contentArea,
}) => {
	return (
		<main id="main-content">
			<Layout>
				<Breadcrumbs links={breadcrumbs} />
			</Layout>
			<SectionHeader
				heading={heading}
				text={text}
				size="large"
				isInEditMode={isInEditMode}
				fullWidth={false}
			/>
			<Layout>
				<Grid
					padding={false}
					margin={false}
					className="my-4 md:mb-25 bg-white rounded-card py-8 px-12"
				>
					<Cell span={12}>
						<CategoryList className="md:flex justify-between">
							{columnList?.map((column, index) => (
								<div key={index} className="mb-5">
									<h2 className="text-black text-h3 font-bold mb-2">
										{column.heading}
									</h2>
									{column.links?.map((item, subIndex) => (
										<CategoryListItem
											key={subIndex}
											url={item.link}
											text={item.text}
										/>
									))}
								</div>
							))}
						</CategoryList>
					</Cell>
				</Grid>
			</Layout>
			{contentArea && <ContentArea contentArea={contentArea} />}
		</main>
	);
};

export default MyPage;
